// extracted by mini-css-extract-plugin
export default {"p":"_3c5b68b3f6 _456bf6214c f352277fec","clr":"_2e789fe02e","dls":"cdb720dd5d"};